export default {
  focusout ({ commit }, name)  {
    commit('setFocus', {
      name,
      value: false
    })
  }
}
